import styled from 'styled-components';

export const Title = styled.h2`
  color: var(--color-text-light);
  font-family: var(--font-tertiary);
  font-weight: var(--font-weight-regular);
  font-size: 3.8rem;
  margin-bottom: 4rem;
`;

export const FormWrapper = styled.div`
  max-width: 46rem;

  label {
    font-family: var(--font-primary);
    font-size: 1.6rem;
    font-weight: normal;
  }
  div.healcode {
    font-size: 1.6rem;
    .hc_prospect {
      .hc-prospect-field {
        margin-top: 1rem;
        margin-bottom: 2rem;
        display: block;
      }
    }
  }

  .healcode-prospect-promo-text {
    font-size: 1.6rem;
    margin-bottom: 3rem;
  }

  .hc_info.stacked {
    width: 100%;
  }

  textarea {
    margin-top: 1rem;
    margin-bottom: 2rem;
    resize: none;
    width: 100% !important;
    height: 26rem;
    padding: 1.6rem 2rem;
    font-family: var(--font-primary);
    &::placeholder {
      font-size: 1.6rem;
      font-family: var(--font-primary);
    }
  }

  select {
    font-weight: bold;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: white;
    background-size: 4rem;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 50%;
    border-radius: 2px;
    margin-right: 2rem;
  }

  input:not([type='checkbox']):not([type='radio']):not([type='submit']),
  select {
    font-family: var(--font-primary);
    width: 100%;
    padding: 1.6rem 2rem;
    margin-top: 1rem;
    margin-bottom: 1rem;

    &::placeholder {
      font-size: 1.6rem;
    }

    &.parsley-error {
      background-color: white;
      border: none;
    }
  }

  .parsley-errors-list.filled > li {
    margin-top: 1rem;
    color: var(--color-secondary);
    font-weight: normal;
    font-size: 1.4rem;
  }
  input[type='checkbox'] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    appearance: none;
    /* For iOS < 15 to remove gradient background */
    background-color: #fff;
    /* Not removed via appearance */

    font: inherit;
    color: #fff;
    width: 2.4rem;
    height: 2.4rem;
    transform: translateY(-0.075em);
    display: inline-grid;
    place-content: center;
    vertical-align: bottom;
    margin: 0 1rem;
    border: none;
  }
  input[type='checkbox']::before {
    content: '';
    color: black;
    width: 2.4rem;
    height: 2.4rem;
  }
  input[type='checkbox']:checked {
    background-color: white;
  }
  input[type='checkbox']:checked::before {
    color: black;
    background-size: 1.6rem;
    background-image: url(https://www.svgrepo.com/show/43432/tick.svg);
    background-position: center;
    background-repeat: no-repeat;
  }

  input[type='submit'] {
    appearance: none;
    border: none;
    box-shadow: none;
    border-radius: var(--border-radius-default) 0;
    outline: none;
    cursor: pointer;
    transition: all var(--transition-default);
    padding: 1.8rem 4rem;
    margin-bottom: 2rem;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-dark);
    background: var(--color-secondary);
    margin-top: 4rem;
    &:hover {
      background: var(--color-black);
      color: var(--color-secondary);
    }
    border-radius: 0;
    padding-right: 3rem;
    padding-left: 3rem;
    border-top-left-radius: var(--border-radius-default);
    border-bottom-right-radius: var(--border-radius-default);
  }

  .hc-privacy-footer .privacy-policy-link {
    color: white;
    margin: 0;
  }
  div.healcode img {
    border: none;
    float: none;
    padding: 0;
    margin: 0;
    display: inline-block;
    mix-blend-mode: color-burn;
  }
`;
